var dsBridge = require("dsbridge");
export default {
  // 回调方法
  callmethod(name, data, callback) {
    console.log('name',name)
    console.log('data',data)
    callback(dsBridge.call(name, data, callback));
  },
  // 注册方法
  registermethod(callback) {
    // dsBridge.register(tag, callback);
    dsBridge.register("asyn", callback);
  },
};
